<template>
    <nav class="meta-nav grid grid__base" :class="bemFacets">
        <div class="meta-nav--container grid--container">
            <div class="grid--row">
                <ul class="u-reset meta-nav--content grid--col">
                    <li class="meta-nav--item meta-nav--item__mobile">
                        <lang-switch current-lang="de"
                                class="meta-nav--link meta-nav--lang-switch"
                                type="inline"
                                :languages="languages"/>
                    </li>

                    <li class="meta-nav--item" v-for="(item, idx) in links" :key="idx">
                        <a class="u-reset  meta-nav--link" :href="item.path" :target="item.external ? '_blank' : null">{{ item.label }}</a>
                    </li>

                    <li class="meta-nav--item meta-nav--item__desktop">
                        <lang-switch
                                class="meta-nav--lang-switch"
                                :languages="languages"/>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>

    import { mapActions } from 'vuex';
    import LangSwitch from 'framework/global-components/dyn/lang-switch/lang-switch';
    import bemMixin from 'framework/mixins/bem';

    export default {
        components: { LangSwitch },
        mixins: [bemMixin('meta-nav')],
        props: {
            /** @type {ILink[]} */
            links: {
                type: Array,
                required: true,
            },

            /** @type {ILink[]} */
            languages: {
                type: Array,
                required: true,
            },
        },

        methods: {
            ...mapActions('navigation', ['setMetanavLinks']),
        },

        mounted() {
            this.setMetanavLinks({ links: this.links, languages: this.languages });
        },
    };
</script>
